import { ExpandableMarkup } from "@mallardbay/lib-react-components"
import React from "react"

import ListingAmenities from "~components/pages/listing/listing-amenities/listing-amenities"
import ListingLicense from "~components/pages/listing/listing-license"
import ListingLocation from "~components/pages/listing/listing-location"
import ListingLodgings from "~components/pages/listing/listing-lodgings"
import ListingSpecies from "~components/pages/listing/listing-species/listing-species"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/test-ids"
import type {
    ListingFieldsFragment,
    PublicListingFieldsFragment,
} from "~graphql/generated/graphql"

export function useListingItems({
    listing,
}: {
    listing?: ListingFieldsFragment | PublicListingFieldsFragment | null
}) {
    const { description, rule, amenities, species } = listing || {}

    return [
        {
            Component: (
                <ExpandableMarkup
                    markup={description}
                    title={COPY.ABOUT}
                    testId={TEST_IDS.LISTING_DESCRIPTION}
                    isLargeTitle
                />
            ),
            shouldRender: Boolean(description),
        },
        {
            Component: (
                <ExpandableMarkup
                    title={COPY.RULES}
                    markup={rule}
                    isLargeTitle
                />
            ),
            shouldRender: Boolean(rule),
        },
        {
            Component: <ListingLodgings listingId={listing?.id} />,
            shouldHideDivider: true,
        },
        {
            Component: <ListingSpecies species={species} />,
            shouldHideDivider: true,
        },
        {
            Component: <ListingAmenities amenities={amenities} />,
        },
        {
            Component: <ListingLicense listing={listing} />,
            shouldHideDivider: true,
        },
        {
            Component: (
                <ListingLocation
                    type={listing?.type}
                    location={listing?.location}
                />
            ),
        },
    ]
}
